export const init = () => {
    if (document.querySelector('.js-fade-window-basic')) {

        const fadeWindows = document.querySelectorAll(".js-fade-window-basic");
        fadeWindows.forEach((item) => {
            const button = item.querySelector('.js-fade-window-basic_switch');
            const content = item.querySelector('.js-fade-window-basic_content');
            const exitButton = item.querySelector('.js-close');
            const switchChange1 = item.querySelector('.js-fade-findow-basic-switch-change-1');
            const switchChange2 = item.querySelector('.js-fade-findow-basic-switch-change-2');
            
            // reason: go webshop-template, content is inside button, which called two times methods. 
            if(content) {
                content.addEventListener('click', (e) => {
                    e.stopPropagation(); 
                });
            }
            

            if(button) {
                button.addEventListener('click', (e) => {
                    content?.classList.toggle("active"); 
                    item.classList.toggle("active");
                    if (switchChange1 && switchChange2) {
                        switchChange1.classList.toggle('active');
                        switchChange2.classList.toggle('active');
                    }
                });
            }
            

            if (exitButton) {
                exitButton.addEventListener('click', (e) => { 
                    e.stopPropagation();  // reason: go webshop-template, content is inside button, which called two times methods.  
                    content?.classList.toggle("active");
                    item.classList.toggle("active");
                });
            }

        });
    }
};

